export default class UnreadNotificationCenter {
  constructor(config = {}) {
    this.containerSelector = config.containerSelector;
    this.modalSelector = config.modalSelector;
    this.listSelector = config.listSelector;
    this.loaderSelector = config.loaderSelector;
    this.emptySelector = config.emptySelector;
    this.totalSelector = config.totalSelector;
    this.markAllSelector = config.markAllSelector;
    this.ownerFilterSelector = config.ownerFilterSelector;
    this.ownerFilterStorageKey = config.ownerFilterStorageKey || 'bo_unread_notifications_owner_filter';
    // Chronos filtre par propriétaire de tâche, Projets Réseaux par projet :
    // seule change la clé envoyée, la liste a la même forme des deux côtés.
    this.filterParamName = config.filterParamName || 'owner_id';
    this.filterListKey = config.filterListKey || 'owners';
    this.onError = config.onError || function() {};

    this.container = document.querySelector(this.containerSelector);
    if (!this.container) {
      return;
    }

    this.badgeElement = this.container.querySelector('.js-unread-count');
    this.triggerElements = this.container.querySelectorAll('.js-unread-trigger');

    this.modalElement = document.querySelector(this.modalSelector);
    this.listElement = document.querySelector(this.listSelector);
    this.loaderElement = document.querySelector(this.loaderSelector);
    this.emptyElement = document.querySelector(this.emptySelector);
    this.totalElement = document.querySelector(this.totalSelector);
    this.markAllButton = document.querySelector(this.markAllSelector);
    this.ownerFilterElement = this.ownerFilterSelector ? document.querySelector(this.ownerFilterSelector) : null;

    this.countUrl = this.container.dataset.countUrl;
    this.ownersUrl = this.container.dataset.ownersUrl;
    this.itemsUrl = this.container.dataset.itemsUrl;
    this.markUrl = this.container.dataset.markUrl;
    this.markTaskUrl = this.container.dataset.markTaskUrl;
    this.markAllUrl = this.container.dataset.markAllUrl;
    this.initialCount = Number.parseInt(this.container.dataset.initialCount || '0', 10) || 0;
    this.selectedOwnerId = this.readSavedOwnerFilter();

    this.bindEvents();
    this.updateCount(this.initialCount);
    this.fetchCount();
  }

  bindEvents() {
    this.triggerElements.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.loadOwners();
        this.loadItems();
      });
    });

    if (this.modalElement) {
      $(this.modalElement).on('shown.bs.modal', () => {
        this.initializeOwnerFilter();
        this.loadOwners();
        this.loadItems();
      });
    }

    if (this.markAllButton) {
      this.markAllButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.markAll();
      });
    }

    if (this.listElement) {
      this.listElement.addEventListener('click', (event) => {
        const target = event.target.closest('.js-notification-link');
        if (!target) {
          return;
        }
        event.preventDefault();
        const itemType = target.dataset.itemType;
        const itemId = target.dataset.itemId;
        const redirectUrl = target.getAttribute('href');

        this.markItem(itemType, itemId)
          .always(() => {
            window.location.href = redirectUrl;
          });
      });
    }

  }

  initializeOwnerFilter() {
    if (!this.ownerFilterElement || !this.modalElement) {
      return;
    }

    if (!$.fn || typeof $.fn.select2 !== 'function') {
      return;
    }

    const $ownerFilter = $(this.ownerFilterElement);

    if (!$ownerFilter.hasClass('select2-hidden-accessible')) {
      $ownerFilter.select2({
        width: '100%',
        allowClear: true,
        placeholder: this.ownerFilterElement.dataset.placeholder || 'Filtrer par proprietaire',
        dropdownParent: $(this.modalElement)
      });

      $ownerFilter.on('select2:open', () => {
        const searchField = document.querySelector('.select2-container--open .select2-search__field');
        if (searchField) {
          searchField.focus();
        }
      });
    }

    $ownerFilter.off('change.unreadOwnerFilter').on('change.unreadOwnerFilter', (event) => {
      this.selectedOwnerId = event.target.value || '';
      this.saveOwnerFilter(this.selectedOwnerId);
      this.loadItems();
    });

    $ownerFilter.val(this.selectedOwnerId || '').trigger('change');
  }

  fetchCount() {
    if (!this.countUrl) {
      return;
    }

    $.ajax({
      url: this.countUrl,
      type: 'GET'
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
      }
    }).fail(() => {
      this.onError('Erreur lors de la récupération des notifications.');
    });
  }

  loadItems() {
    if (!this.itemsUrl || !this.listElement) {
      return;
    }

    this.setLoadingState(true);

    const requestData = {};
    if (this.selectedOwnerId) {
      requestData[this.filterParamName] = this.selectedOwnerId;
    }

    $.ajax({
      url: this.itemsUrl,
      type: 'GET',
      data: requestData
    }).done((response) => {
      const items = (response && response.items) || [];
      this.renderItems(items);

      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread, { updateTotal: false });
      }

      if (response && typeof response.filtered_total_unread === 'number') {
        this.updateModalTotal(response.filtered_total_unread);
      } else if (response && typeof response.total_unread === 'number') {
        this.updateModalTotal(response.total_unread);
      }
    }).fail((jqXHR, textStatus) => {
      if (textStatus === 'abort' || (jqXHR && (jqXHR.status === 0 || jqXHR.statusText === 'abort'))) {
        return;
      }
      this.onError('Erreur lors du chargement des commentaires.');
    }).always(() => {
      this.setLoadingState(false);
    });
  }

  loadOwners() {
    if (!this.ownersUrl || !this.ownerFilterElement) {
      return;
    }

    $.ajax({
      url: this.ownersUrl,
      type: 'GET'
    }).done((response) => {
      this.renderOwnerOptions((response && response[this.filterListKey]) || []);
    }).fail(() => {
      this.onError('Erreur lors du chargement du filtre des notifications.');
    });
  }

  renderOwnerOptions(owners) {
    if (!this.ownerFilterElement) {
      return;
    }

    const selectedOwnerId = this.selectedOwnerId || '';
    const placeholder = this.ownerFilterElement.dataset.placeholder || 'Filtrer par proprietaire';

    this.ownerFilterElement.innerHTML = '';

    const allOwnersOption = document.createElement('option');
    allOwnersOption.value = '';
    allOwnersOption.textContent = placeholder;
    this.ownerFilterElement.appendChild(allOwnersOption);

    owners.forEach((owner) => {
      if (!owner || !owner.id) {
        return;
      }

      const option = document.createElement('option');
      option.value = String(owner.id);
      option.textContent = owner.name || `#${owner.id}`;
      this.ownerFilterElement.appendChild(option);
    });

    const ownerIds = owners.map((owner) => String(owner.id));
    if (selectedOwnerId && ownerIds.indexOf(String(selectedOwnerId)) === -1) {
      this.selectedOwnerId = '';
      this.saveOwnerFilter('');
    }

    $(this.ownerFilterElement).val(this.selectedOwnerId || '').trigger('change');
  }

  renderItems(items) {
    if (!this.listElement) {
      return;
    }

    this.listElement.innerHTML = '';
    this.listElement.classList.toggle('d-none', items.length === 0);

    if (!items.length) {
      if (this.emptyElement) {
        this.emptyElement.classList.remove('d-none');
      }
      return;
    }

    if (this.emptyElement) {
      this.emptyElement.classList.add('d-none');
    }
    this.listElement.classList.remove('d-none');

    items.forEach((item) => {
      const listItem = document.createElement('li');
      listItem.className = 'list-group-item py-3';

      const wrapper = document.createElement('div');
      wrapper.className = 'd-flex justify-content-between align-items-start flex-wrap';

      const content = document.createElement('div');
      content.className = 'flex-grow-1 pr-3';

      const title = document.createElement('h6');
      title.className = 'mb-1 d-flex align-items-center';

      const typeBadge = document.createElement('span');
      typeBadge.className = 'badge badge-light text-uppercase mr-2';
      // Le libellé vient du serveur quand il le fournit : hors Chronos, un
      // non-lu ne pend pas à une commande ni à une étude.
      typeBadge.textContent = item.object_type_label
        || (item.object_type === 'Order' ? 'Commande' : (item.object_type === 'StudyRequest' ? "Demande d'étude" : 'Tâche'));
      title.appendChild(typeBadge);

      const subjectLabel = document.createElement('span');
      subjectLabel.className = 'font-weight-bold';
      subjectLabel.textContent = item.subject_label || item.service_number || '--';
      title.appendChild(subjectLabel);

      content.appendChild(title);

      if (item.message) {
        const message = document.createElement('p');
        message.className = 'mb-1 text-muted';
        message.textContent = item.message;
        content.appendChild(message);
      }

      const meta = document.createElement('small');
      meta.className = 'text-muted';
      meta.textContent = item.created_at_hr || '';
      content.appendChild(meta);

      wrapper.appendChild(content);

      if (item.link) {
        const actions = document.createElement('div');
        actions.className = 'text-right mt-2 mt-md-0';

        const link = document.createElement('a');
        link.className = 'btn btn-sm btn-primary js-notification-link';
        link.href = item.link;
        link.dataset.itemType = item.type;
        link.dataset.itemId = item.id;
        link.textContent = 'Ouvrir';

        actions.appendChild(link);
        wrapper.appendChild(actions);
      }

      listItem.appendChild(wrapper);
      this.listElement.appendChild(listItem);
    });
  }

  markItem(itemType, itemId) {
    if (!this.markUrl) {
      return $.Deferred().resolve();
    }

    return $.ajax({
      url: this.markUrl,
      type: 'POST',
      data: {
        item_type: itemType,
        item_id: itemId
      }
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
        this.loadItems();
      }
    }).fail(() => {
      this.onError('Impossible de mettre à jour la notification.');
    });
  }

  markAll() {
    if (!this.markAllUrl) {
      return;
    }

    this.setLoadingState(true);

    $.ajax({
      url: this.markAllUrl,
      type: 'POST'
    }).done((response) => {
      if (response && typeof response.total_unread === 'number') {
        this.updateCount(response.total_unread);
      } else {
        this.updateCount(0);
      }
      this.renderItems([]);
    }).fail(() => {
      this.onError('Impossible de marquer toutes les notifications comme lues.');
    }).always(() => {
      this.setLoadingState(false);
    });
  }

  setLoadingState(isLoading) {
    if (this.loaderElement) {
      this.loaderElement.classList.toggle('d-none', !isLoading);
    }
    if (this.listElement) {
      this.listElement.classList.toggle('d-none', isLoading);
    }
  }

  updateCount(count, options = {}) {
    const updateTotal = options.updateTotal !== false;
    const safeCount = count || 0;

    if (this.badgeElement) {
      if (safeCount > 0) {
        this.badgeElement.classList.remove('d-none');
        this.badgeElement.textContent = safeCount;
      } else {
        this.badgeElement.classList.add('d-none');
        this.badgeElement.textContent = 0;
      }
    }

    if (updateTotal) {
      this.updateModalTotal(safeCount);
    }
  }

  updateModalTotal(count) {
    if (this.totalElement) {
      this.totalElement.textContent = count || 0;
    }
  }

  readSavedOwnerFilter() {
    try {
      return window.localStorage.getItem(this.ownerFilterStorageKey) || '';
    } catch (_error) {
      return '';
    }
  }

  saveOwnerFilter(ownerId) {
    try {
      if (ownerId && ownerId.length > 0) {
        window.localStorage.setItem(this.ownerFilterStorageKey, ownerId);
      } else {
        window.localStorage.removeItem(this.ownerFilterStorageKey);
      }
    } catch (_error) {
      // Ignore localStorage availability errors.
    }
  }
}
